<h2 mat-dialog-title>{{ 'PAGES.DOMAINS.ADD_DOMAIN_MODAL.TITLE' | translate }}</h2>
<mat-dialog-content>
  <app-custom-domain-fields (domains)="domains = $event"></app-custom-domain-fields>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="closeDialog()" [disabled]="disableInput">
    {{ 'PAGES.DOMAINS.ADD_DOMAIN_MODAL.BUTTONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button (click)="clickSubmit()" color="primary" [disabled]="disableButton">
    <glxy-button-loading-indicator [isLoading]="disableInput">
      {{ 'PAGES.DOMAINS.ADD_DOMAIN_MODAL.BUTTONS.ADD_DOMAIN' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
